// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"ferris-wheel"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M8.99959 22H14.9996M8.99959 22L8.99959 17.3263M8.99959 22H5.99902M14.9996 22V17.3261M14.9996 22H17.999M8.99959 17.3263L11.999 11L14.9996 17.3261M8.99959 17.3263C9.90879 17.7582 10.9259 17.9998 11.9994 17.9998C13.0731 17.9998 14.0903 17.7581 14.9996 17.3261M20.9994 10.9998H18.9998M18.9998 10.9998C18.9998 7.13383 15.8658 3.99982 11.9998 3.99982M18.9998 10.9998C18.9998 14.8658 15.8658 17.9998 11.9998 17.9998C8.1338 17.9998 4.99979 14.8658 4.99979 10.9998M4.99979 10.9998L3 11M4.99979 10.9998C4.99979 7.13383 8.1338 3.99982 11.9998 3.99982M11.9998 3.99982L11.9994 2M19.7922 6.49889L18.0601 7.49889M5.93576 14.4989L4.2037 15.4989M19.7918 15.4988L18.0598 14.4988M5.93541 7.49879L4.20337 6.49879M16.4987 3.20441L15.4987 4.93646M8.49869 4.93683L7.49869 3.20478","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-ferris-wheel')
export default class FerrisWheelIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'ferris-wheel',
    }
  }
}
